/**
 * De tekst van de oogstbewaking, in de taal van het scherm (opdracht Frank 21 oktober
 * 2026). De backend beslist OF er iets te melden is (`services/oogst_bewaking.py`) en
 * stuurt de soort en de datum; deze module maakt er de zin van.
 *
 * PUUR: `t` en `taal` komen van de aanroeper.
 */
import { localeVan } from "./datum";

export function meldingDatum(iso, taal) {
  return new Date(iso).toLocaleDateString(localeVan(taal), { day: "numeric", month: "long", year: "numeric" });
}

/** { titel, uitleg } voor een melding, of null als er niets te melden is. */
export function oogstMeldingTekst(melding, t, taal) {
  if (!melding) return null;
  const datum = melding.sinds ? meldingDatum(melding.sinds, taal) : null;
  if (melding.soort === "mislukt") {
    return {
      titel: t("De laatste oogst is mislukt op {datum}", { datum }),
      uitleg: melding.reden ? t("Reden: {reden}", { reden: melding.reden }) : t("De reden is niet bewaard."),
    };
  }
  const titel = datum
    ? t("De oogst heeft sinds {datum} niets meer geleerd", { datum })
    : t("De oogst heeft nog niets geleerd");
  if (melding.soort === "provider") {
    return { titel, uitleg: t("De oogst leest alleen met het lokale model. Kies Ollama in Instellingen.") };
  }
  if (melding.soort === "klok_uit") {
    return { titel, uitleg: t("De oogstklok staat uit in deze installatie.") };
  }
  if (melding.soort === "klok_stil") {
    return { titel, uitleg: t("De oogstklok heeft meer dan 24 uur geen ronde gedraaid. Start NovaMund opnieuw.") };
  }
  return null;
}

/**
 * Veel wachtende voorstellen (besluit Frank 22 oktober 2026): er is geen maximum en
 * de oogst gaat door, maar boven de tien staat het aantal bovenaan Geheugen.
 */
export function wachtendTekst(wachtend, t) {
  if (!wachtend || wachtend.soort !== "veel_wachtend") return null;
  return {
    titel: t("{aantal} voorstellen wachten op je", { aantal: wachtend.open }),
    uitleg: t("Neem ze aan of klik ze weg wanneer het je uitkomt; de oogst gaat gewoon door en er verloopt niets."),
  };
}
